module.exports = __webpack_public_path__ + "img/logo.6f1ad1b1.png";